import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivities as GetActivitiesQuery,
    GetActivities_activities as Activity,
} from 'nutshell-graphql-types';

import GET_ACTIVITIES from '../queries/get-activities.graphql';

export function useGetActivities(
    entityId: string,
    status: number,
    limit?: number
): {
    activities: Activity[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, loading, refetch} = useQuery<GetActivitiesQuery, Record<any, any>>(
        GET_ACTIVITIES,
        {
            variables: {
                entityId,
                status,
                limit: limit ? limit : 100,
            },
        }
    );

    const activities = data ? data.activities : [];

    return {
        activities,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
